module.exports = __webpack_public_path__ + "static/media/forsaLogo.fa016bbe.png";